/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse { 
    tournamentPlayerId?: number;
    playerId?: number;
    firstName?: string;
    lastName?: string;
    position?: number;
    positionTied?: boolean;
    positionDisplay?: string;
    sortIndex?: number;
    startToParDisplay?: string;
    totalToParDisplay?: string;
    roundToParDisplay?: string;
    statusCode?: string;
    roundsCompleted?: number;
    totalToPar?: number;
    isAmateur?: boolean;
    thru?: number;
    money?: number;
}